import * as React from 'react';

const DisplayContext = React.createContext({ debugProductOptionsUi: false, debugDisabledOptions: false, debugIncompatibleOptions: false });

export { DisplayContext };
//# sourceMappingURL=displayContext.mjs.map
